import { render, staticRenderFns } from "./logwood-history-date.vue?vue&type=template&id=c941350c&scoped=true&"
import script from "./logwood-history-date.vue?vue&type=script&lang=ts&"
export * from "./logwood-history-date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c941350c",
  null
  
)

export default component.exports